import blog4 from './The Power of Personal Branding in Fashion.jpg';
import blog5 from './Engaging with Fashion Communities Through Storytelling.png';
import blog1 from './image01.png'
import blog6 from './image6.png'
import blog7 from './Image7.png'
import blog8 from './image8.jpg'
import blog9 from './image9.jpg'
import blog10 from './image10.png'
import blog11 from './image11.jpg'
import blog12 from './image12.jpg'

export {
    blog1,
    blog4,
    blog5,
    blog6,
    blog7,
    blog8,
    blog9,
    blog10,
    blog11,
    blog12,
}
